import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule, StoreDevtoolsOptions } from '@ngrx/store-devtools';

import { environment } from '../../environments/environment';

import { effects, reducers } from './index';
import { metaStorageReducers } from './meta-reducers/local-storage-cache.reducer';
import { CommonModule } from '@angular/common';

export const StoreDevtoolsConfig: StoreDevtoolsOptions = {
  maxAge: 25,
  logOnly: environment.production,
  autoPause: true,
  trace: false,
  traceLimit: 75,
};

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forRoot(reducers, {
      metaReducers: metaStorageReducers,
    }),
    EffectsModule.forRoot(effects),
    StoreDevtoolsModule.instrument(StoreDevtoolsConfig),
  ],

  providers: [],
})
export class AppStoreModule {}
